<template>
  <div>
    <h2 class="text-center my-5 fw-bold fs-1">
      Personal Information President of the Student Union Candidate
    </h2>

    <CRow class="mb-5 justify-content-center" v-for="candidate in candidates" :key="candidate.candidateNumber">
      <CCol style="max-width: 1200px;">
        <div class="d-flex align-items-center justify-content-between">
          <!-- การ์ด -->
          <CCard class="p-4 shadow flex-grow-1" style="border-radius: 20px;">
            <CCardBody class="d-flex flex-column flex-lg-row align-items-start">
              <img
                  :src="candidate.image"
                  :alt="candidate.name"
                  class="rounded mb-4 mb-lg-0 align-self-center align-self-lg-start"
                  style="width: 180px; height: 240px; object-fit: cover; margin-right: 40px;"
              />
              <div class="ms-lg-4">
                <p class="mb-4" style="font-size: 1.2rem;"><strong>Name:</strong> {{ candidate.name }}</p>
                <p class="mb-4" style="font-size: 1.2rem;"><strong>Student ID:</strong> {{ candidate.studentId }}</p>
                <p class="mb-4" style="font-size: 1.2rem;"><strong>School:</strong> {{ candidate.school }}</p>
                <p class="mb-4" style="font-size: 1.2rem;"><strong>Major:</strong> {{ candidate.major }}</p>
                <CButton color="warning" size="lg">Candidate Policy</CButton>
              </div>
            </CCardBody>
            <div class="text-center text-muted fs-5 mt-3">No.{{ candidate.candidateNumber }}</div>
          </CCard>

          <div v-if="isVotingOpen" class="d-flex flex-column align-items-center ms-5" style="min-width: 110px; margin-left: 30px;">
            <label
                :for="'check-'+candidate.candidateNumber"
                class="text-center"
                style="font-weight: 600;"
            >
              Vote
            </label>

            <label :for="'check-'+candidate.candidateNumber" class="custom-checkbox-wrapper">
              <input
                  :id="'check-'+candidate.candidateNumber"
                  type="checkbox"
                  :value="candidate.candidateNumber"
                  v-model="selectedCandidates"
                  class="custom-checkbox"
              />
              <span class="custom-checkmark"></span>
            </label>
          </div>

        </div>
      </CCol>
    </CRow>

    <vote :isVotingOpen="isVotingOpen" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import vote from '@/projects/views/member/components/vote.vue'

export default {
  name: 'member',
  components: { vote },

  props: {
    icon: {
      type: String,
      default: 'cil-bell'
    },
    caption: {
      type: String,
      default: 'ศูนย์แจ้งเหตุฉุกเฉิน'
    },

  },
  data() {
    return {
      isVotingOpen: true, // ✅ เปลี่ยนเป็น false เพื่อทดสอบปิดโหวต
      selectedCandidates: [],
      candidates: [
        {
          name: 'Jisoo Kim',
          studentId: '6431505555',
          school: 'School of Cosmetic Science',
          major: 'Beauty Technology',
          image: '/img/avatars/8.jpg',
          candidateNumber: 1,
        },
        {
          name: 'Lalisa Manoban',
          studentId: '6531701123',
          school: 'School of Dentistry',
          major: 'Dental Surgery',
          image: '/img/avatars/8.jpg',
          candidateNumber: 2,
        },
      ]
    }
  },

  mounted() {

  },

  created() {
    this.onInit();
  },

  beforeDestroy() {

  },

  methods: {
    onInit() {

      this.$store.dispatch("auth/message",{})
    },
  },

  computed: {
    ...mapGetters({
      messages: 'auth/message',
    })
  },

  watch: {

  }
}

</script>
<style scoped>
.custom-checkbox-wrapper {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

/* ซ่อน checkbox ของจริง */
.custom-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

/* วงกลมที่แสดงแทน checkbox */
.custom-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #8c1515;
  background-color: white;
  box-sizing: border-box;
  transition: background-color 0.2s, border-color 0.2s;
}

/* เครื่องหมายถูก */
.custom-checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

/* แสดงเครื่องหมายถูกเมื่อเลือก */
.custom-checkbox:checked + .custom-checkmark::after {
  display: block;
  left: 12px;
  top: 5px;
  width: 12px;
  height: 24px;
  border: solid white;
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
}

/* เมื่อเลือก เปลี่ยนสีพื้นหลังและขอบ */
.custom-checkbox:checked + .custom-checkmark {
   background-color: #8c1515;
 }
</style>